import { X } from 'lucide-react';

const ViewerModal = ({ item, onClose }) => {

    console.log("item", item)

    return (<div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-[100] animate-fade-in-up">
        <div className="bg-white rounded-lg shadow-2xl w-full max-w-[95vw] sm:max-w-3xl max-h-[80vh] flex flex-col">

            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
                <h2 className="text-xl font-bold text-gray-800">{item.title}</h2>
                <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200 transition">
                    <X />
                </button>
            </div>

            {/* Content Area */}
            <div className="p-6 overflow-y-auto">
                {item.category === 'Video' ? (
                    <iframe
                        src={item.content}
                        title={item.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="w-full aspect-video"
                    ></iframe>
                ) :
                    item.type === 'EDUCATION' ? (
                        <iframe
                            src={item.url}
                            title={item.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="w-full aspect-video"
                        ></iframe>
                    ) : (
                        <p className="text-gray-700 whitespace-pre-line">{item.content}</p>
                    )}
            </div>
        </div>
    </div>
    )
};

export default ViewerModal;